module.exports = __webpack_public_path__ + "img/selected0-min.dc2526b0.png";